import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { ComponentsComponent } from './components/components.component';
import { ProfileComponent } from './examples/profile/profile.component';
import { SignupComponent } from './examples/signup/signup.component';
import { LandingComponent } from './examples/landing/landing.component';
import { NucleoiconsComponent } from './components/nucleoicons/nucleoicons.component';
import { HomeComponent } from './home/home.component';
import { ErrorComponent } from './error/error.component';
import { SubmittedComponent } from './submitted/submitted.component';
import { ExpiredComponent } from './expired/expired.component';
import { NotAvailableComponent } from './not-available/not-available.component';
import {  PharmacyRegistrationComponent } from './pharmacy-registration/pharmacy-registration.component';
import { RegistrationCompletedComponent } from './registration-completed/registration-completed.component';

const routes: Routes =[
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home/:token',             component: HomeComponent },
    { path: 'home',             component: HomeComponent },
    { path: 'error',             component: ErrorComponent },
    { path: 'expired',             component: ExpiredComponent },
    { path: 'submitted',             component: SubmittedComponent },
    { path: 'not-available',             component: NotAvailableComponent },
    { path: 'pharmacy-registration',             component: PharmacyRegistrationComponent },
    { path: 'registration-completed',             component: RegistrationCompletedComponent },
    { path: 'expansion-of-services',             component: HomeComponent },

    // { path: 'component',             component: ComponentsComponent },
    // { path: 'user-profile',     component: ProfileComponent },
    // { path: 'signup',           component: SignupComponent },
    // { path: 'landing',          component: LandingComponent },
    // { path: 'nucleoicons',      component: NucleoiconsComponent }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes,{
      useHash: true
    })
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
